import IconButton from "../IconButton/IconButton"
import styles from "./ExpandCollapseSidebarButton.module.scss"
import { dialogsTestIds } from "../../utility/tests/testId/dialogs"
import React from "react"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import cn from "classnames"

interface ExpandCollapseSidebarButtonProps {
    icon: IconProp
    onClick: () => void
    variant?: string
    className?: string
    iconClassName?: string
    buttonTestId?: string
}

export const ExpandCollapseSidebarButton = (props: ExpandCollapseSidebarButtonProps) => {
    const { variant = "outline-light", buttonTestId = dialogsTestIds.collapseSidebar, ...restProps } = props
    return (
        <IconButton
            {...restProps}
            iconSize={"2x"}
            role="button"
            variant={variant}
            className={cn(styles.button, restProps.className)}
            iconClassName={cn(styles.button__collapseIcon, restProps.iconClassName)}
            testId={buttonTestId}
        />
    )
}
